import { computed } from 'vue';
import type { Ref } from 'vue';
import { useNow } from '@vueuse/core';
import { buildPosTableViews } from '@/domain/pos/table-views';
import { attachReservationHints } from '@/domain/reservations/pos-table-hints';
import { getReservationTimeZone } from '@/domain/reservations/reservation-time';
import { OrderType } from '@/enums/OrderEnums';
import { useOrdersStore } from '@/stores/orders.store';
import { useRestaurantStore } from '@/stores/restaurant.store';
import { useReservationsUpcoming } from './use-reservations-upcoming';

/** One view model for the POS grid, floor and table-page navigation. */
export function usePosReservationTables(search?: Readonly<Ref<string>>) {
  const restaurant = useRestaurantStore();
  const orders = useOrdersStore();
  const upcoming = useReservationsUpcoming();
  const now = useNow({ interval: 30_000 });
  const tables = computed(() =>
    attachReservationHints(
      buildPosTableViews(
        restaurant.tables,
        orders.pendingOrdersByType?.[OrderType.Seat] ?? [],
        search?.value ?? ''
      ),
      upcoming.list.value ?? [],
      now.value,
      upcoming.settings.value?.toleranceMin ?? 15,
      getReservationTimeZone(
        restaurant.selectedBranch?.location,
        restaurant.restaurant?.country
      )
    )
  );
  return { tables, now };
}
